import Render from '@Views/root/calendar/planning/context-main.html'
import { Component, Vue } from 'vue-property-decorator'

@Render
@Component({})
export class ContextMain extends Vue {}